<template>
    <div class="list">
        <NavBar></NavBar>
        <!-- 123LLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLL -->
        <van-col span="24" style="padding-top:35px;text-align:center">
            <!-- <van-icon name="user-circle-o" style="font-size:80px"/> -->
            <van-image round width="6rem" height="6rem" :src="headImgUrl" />
        </van-col>
        <van-col span='24' style="margin-top:5px;text-align:center;font-weight:bold;margin-bottom:30px">账户中心</van-col>
        <van-cell-group>
            <van-cell title="认证信息" @click="openInmation" is-link :value="authentication" />
            <van-cell title="联系我们" @click="openContact" is-link />
            <van-cell title="用户服务协议" @click="openUserdia" is-link />
            <van-cell title="隐私条款" @click="openHides" is-link />
            <van-cell title="当前版本" value="V1.0" />
        </van-cell-group>
        <van-divider :style="{ color: 'gray', borderColor: 'gray', padding: '0 16px',fontSize:'12px',marginBottom:'70px'}">
            威海南海新区住宅维修资金宣
        </van-divider>
        <div class="flex">
            <van-col :span="24" class="house_button">
                <van-button color="#e1251b" size="normal" @click="goHome">返回首页</van-button>
            </van-col>
            <!-- <van-button type="danger" size="large" @click="goHome">返回首页</van-button> -->
        </div>
        <!-- 认证信息的弹框 -->
        <van-dialog v-model:show="inmation" title="认证信息" show-cancel-button :show-confirm-button='false'>
            <div style="padding:10px 15px;font-size:14px">
                <van-col span='24'>业主姓名：{{realName}}</van-col>
                <van-col span='24' style="margin:15px 0">证件类型：身份证</van-col>
                <van-col span='24'>证件号码：{{realIdCard}}</van-col>
                <van-col span='24' style="margin:15px 0">手机号码：{{phone}}</van-col>
            </div>
        </van-dialog>
        <!-- 联系我们的弹框 -->
        <van-dialog v-model:show="contact" :title="obj.title" show-cancel-button :show-confirm-button='false'>
            <div style="padding:10px 15px;">
                <div v-html="obj.content"></div>
                <!-- <van-col span='24'>联系地址：威海市南海新区XX路111号</van-col>
                <van-col span='24' style="margin:15px 0">联系电话：</van-col>
                <van-col span='24'>XX科室：123456</van-col>
                <van-col span='24' style="margin:15px 0">XX科室：123456</van-col>
                <van-col span='24'>XX科室：123456</van-col>
                <van-col span='24' style="margin:15px 0">XX科室：123456</van-col>
                <van-col span='24'>XX科室：123456</van-col>
                <van-col span='24' style="margin:15px 0">XX科室：123456</van-col>
                <van-col span='24'>XX科室：123456</van-col>
                <van-col span='24' style="margin:15px 0">XX科室：123456</van-col> -->
            </div>
        </van-dialog>
        <!-- 用户服务协议的弹框 -->
        <van-dialog v-model:show="userdia" title="用户服务协议" :lock-scroll='false' show-cancel-button :show-confirm-button='false'>
            <div style="padding:10px 15px;font-size:14px;height:250px;overflow:auto">
引言

欢迎您使用南海新区维修资金服务平台！

南海新区维修资金服务平台（以下简称“南海新区维修资金服务平台")根据《用户服务协议》（以下简称“本协议")为您提供服务。

为使用南海新区维修资金服务平台服务，请您务必审慎阅读、充分理解本协议各条款内容，特别是免除或者限制责任的条款、对用户权利进行限制的条款等。限制、免责条款或者其他涉及您重大权益的条款可能以加粗形式提示您重点注意。

除非您已充分阅读、完全理解并接受本协议所有条款，否则您无权注册、登录或使用南海新区维修资金服务平台服务。您点击“登录（具体措辞详见注册页面）”或您进行注册、使用、获取用户帐号、登录及使用相关服务的行为或者以其他任何明示或者默示方式表示接受本协议的，均视为您已阅读并同意签署本协议。

如果您因年龄、智力等因素而不具有完全民事行为能力，请在法定监护人（以下简称监护人)的陪同下阅读和签署本协议。

您有违反本协议的任何行为时，南海新区维修资金服务平台有权根据您违反约定的情形单方采取限制、中止或终止向您提供服务等措施，并有权追究您相关责任。

一、定义与解释


如无特别说明，下列术语在本协议中的定义为：
 
1.1用户是指注册、登录、使用南海新区维修资金服务平台的个人或组织，在本协议中更多地称为“您＂。

1.2南海新区维修资金服务平台是用户通过“实人＋实名“身份认证核验，即可在平台通办多项民生服务事项的微信平台。（以下简称“南海新区维修资金服务平台＇）

1.3人脸识别验证身份功能是指由第三方认证机构提供的可信身份证认证平台，腾讯身份认证提供的身份核验数据及技术支持。

1.4南海新区维修资金服务平台账号是指您在南海新区维修资金服务平台通过人脸识别或微信支付等方式注册的，用于登录南海新区维修资金服务平台办理事项的帐号。（以下简称“南海新区维修资金服务平台账号)

二、协议适用范围


2.1	本协议是南海新区维修资金服务平台制定的关于获取和使用南海新区维修资金服务平台帐号的相关规则。本规则适用于由南海新区维修资金服务平台提供的需要注册或使用南海新区维修资金服务平台帐号的全部软件或服务。

2.2	本协议项下的登录服务包括两种情况：南海新区维修资金服务平台向用户提供的通过人脸识别注册帐号登录使用第三方应用（包括第三方网站、系统或导出的数据等）的服务；南海新区维修资金服务平台向用户提供的通过微信支付密码帐号登录使用第三方应用（包括第三方网站、系统或导出的数据等）的服务
（以下简称本服务）。


（本协议中的第三方“若无特别说明，均为为用户提供相应网站、应用或其他服务的政府部门、公用企事业单位或其他公共服务组织，南海新区维修资金服务平台将在具体应用页面底部提示提供方。）
 
2.3	您通过南海新区维修资金服务平台提供的帐号使用相关的软件和服务时，须同时遵守各项服务的单独协议。

三、帐号注册及管理


3.1	帐号注册

3.1.1	用户可选择人脸识别验证身份方式或微信支付方式注册登录南海新区维修资金服务平台账号。新用户在通过人脸识别验证身份功能、微信支付方式登录时系统将为您自动匹配—个帐号，帐号密码由您自行设置并由您负责保管。

3.1.2	您在注册及使用南海新区维修资金服务平台服务时，必须向南海新区维修资金服务平台提供真实、准确、完整、合法有效的资料，且有义务维持并及时更新您的资料。根据实名认证方式的不同，个人所需提供的实名认证资料包括但不限于姓名、身份证信息等。若南海新区维修资金服务平台有合理理由怀疑您提供的身份信息及相关资料错误、不实、过时或不完整的，南海新区维修资金服务平台有权限制或停止向您提供部分或全部服务，您同时须承担因此引起的相应责任及后果。

3.1.3	您不得冒用他人名义申请非本人的用户帐号。如有违反，经核实后，南海新区维修资金服务平台或第三方服务平台有权删除其帐号。对于冒用他人名义申请非本人的用户帐号而引起的—切责任，由冒用者承担。

3.1.4	若您为个人用户，您确认并授权，南海新区维修资金服务平台有权要求核对您的有效身份信息，并留存有效必要文件，您应积极配合，否则南海新区维修资金服务平台有权限制或停止向您提供部分或全部服务。

3.2	帐号管理

3.2.1	南海新区维修资金服务平台帐号的所有权归南海新区维修资金服务平台所有，用户完成申请注册手续后，仅获得帐号的使用权，且该使用权仅属于初始
 
申请注册人。

3.2.2	您有责任妥善保管注册帐号信息及帐号密码的安全，您需要对您注册帐号以及密码下的行为承担法律责任。当在您知悉您的帐号已经失密或者可能已经失密时，您应立即通知南海新区维修资金服务平台。

3.2.3	您确认只有您本人可以使用您的账号。在您决定不再使用该账号时，您应向南海新区维修资金服务平台申请注销该账号。您应对因您未能遵守本款约定而发生的任何损失、损毁及其他不利后果负责。

3.2.4	如果您当前使用的帐号并不是您初始申请注册的或者不是通过南海新区维修资金服务平台提供的其他途径获得的，您不得用该号码登录或进行任何操作，并请您在第—时间通知南海新区维修资金服务平台。

3.2.5	如您违反相关法律法规、本规则或其他相关协议、规则，南海新区维修资金服务平台有权限制、中止、冻结或终止您对帐号的使用，且根据实际情况决定是否恢复您对帐号的使用，而由此产生的损失由您自行承担。


四、用户个人信息保护


4.1	南海新区维修资金服务平台非常重视对用户个人信息的保护。南海新区维修资金服务平台将按照本协议及《南海新区维修资金服务平台隐私政策》的规定收集、使用、储存和分享您的个人信息。本协议对个人信息保护规定的内容与上述《南海新区维修资金服务平台隐私政策》有相冲突的，及本协议对个人信息保护相关内容未作明确规定的，均应以《南海新区维修资金服务平台隐私政策》的内容为准。

4.2	如您认为您的个人信息被南海新区维修资金服务平台超目的使用、或被其他用户侵权，请立即与南海新区维修资金服务平台联系，并按照要求提供相应的证明资料，南海新区维修资金服务平台将及时调查核实处理。
 
4.3	—般情况下，你可随时浏览、修改自己提交的信息，但出于安全性和身份识别的考虑，您可能无法修改注册时提供的初始注册信息及其他验证信息。

4.4	南海新区维修资金服务平台将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。

4.5	对于南海新区维修资金服务平台会如何收集、使用、存储和保护您的个人信息及您享有何种权利，您还可以阅读《隐私政策》予以进—步了解。

五、用户行为规范


5.1	您不得因非正常使用服务之目的恶意注册、获取南海新区维修资金服务平台帐号。若经过南海新区维修资金服务平台判断，认为您使用的帐号是恶意注册、获取的号码，南海新区维修资金服务平台有权对相应帐号采取限制、中止或终止使用等措施。

5.2	您在使用本服务时，须通过南海新区维修资金服务平台提供的技术接口、登录页面及其他合法通道等进行平台或第三方账号和密码输入、个人信息授权等操作；否则，可能会造成的帐号、密码泄漏或其他损失等由您自行承担。

5.3	第三方负责其提供的具体网站、应用或其他服务的合法性、安全性以及真实性，若因任何第三方原因，造成您损失的，由第三方承担全部责任。

5.4	您通过本服务使用平台或第三方帐号登录、使用的网站、应用或服务等，应遵循您与第三方之间的协议、约定或第三方相关的规则等。

5.5	您在使用平台提供的服务过程中，必须遵循法律法规、规章、规范性文件及政策要求的规定，遵守所有与平台、网络服务有关的网络协议、规定和程序，并不得利用南海新区维修资金服务平台从事以下行为：

(1)	发布、传送、传播、储存违反国家法律、危害国家安全统—、社会稳定、公序良俗、社会公德以及侮辱、诽谤、淫秽、暴力的内容；
(2)	发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；

(3)	虚构事实、隐瞒真相以误导、欺骗他人；

(4)	发表、传送、传播广告信息及垃圾信息；

(5)	利用平台传输、发布违反国家法律法规政策的任何内容（信息）、涉及国家秘密和／或安全的信息、防碍互联网运行安全的信息；侵害他人合法权益的信息和／或其他有损于社会秩序、社会治安、公共道德的信息或内容、任何骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料等，且不得为他人实施上述行为提供任何便利；

(6)	以任何技术手段或其他方式干扰南海新区维修资金服务平台及各项政务服务网上服务系统正常运行的，或干扰其他用户对南海新区维修资金服务平台服务使用的；

(7)	通过任何方式搜集南海新区维修资金服务平台服务中其他用户的用户名、电子邮件等相关信息，并以发送垃圾邮件、连锁邮件、垃圾短信、即时消息等方式干扰、骚扰其他用户；

(8)	从事其他违反法律法规、政策及公序良俗、社会公德等的行为或对互联网的正常运转造成不利影响的行为。

5.6	南海新区维修资金服务平台服务仅供您个人使用，除非经南海新区维修资金服务平台书面许可，您不得进行以下行为：

(1)	通过南海新区维修资金服务平台发布包含广告、宣传、促销等内容的信息；

(2)	将南海新区维修资金服务平台提供的服务再次许可他人使用；

(3)	其他超出南海新区维修资金服务平台正常服务功能之外的行为。
5.7	您充分了解并同意，您必须为自己注册账号下的—切行为负责，包括您所发表的任何内容、您进行的各项操作、您进行的授权以及由此产生的任何后果。

5.8	如果南海新区维修资金服务平台发现或收到他人举报您发布的信息违反前述约定或本协议其他约定的，南海新区维修资金服务平台有权进行独立判断并采取技术手段予以删除、屏蔽或断开相关的信息链接。同时，南海新区维修资金服务平台有权视您的行为性质，采取包括但不限于暂停或终止本服务、追究法律责任等措施。南海新区维修资金服务平台有权判断用户的行为是否符合平台服务条款规定的权利，如果南海新区维修资金服务平台认为用户违背了本协议、法律法规政策等规定，南海新区维修资金服务平台有权随时变更、中断或终止部分或全部服务的权利，且无需事先告知。

六、知识产权声明


6.1	南海新区维修资金服务平台在服务中提供的任何软件、网站、商业标识、版面设计、排版方式、文字、图片、图形、音频、视频、有关数据等内容、功能和服务的著作权、商标权、专利权、商业秘密等知识产权均受中华人民共和国法律法规和相应的国际条约保护，南海新区维修资金服务平台所有者或技术支持方享有上述知识产权，但相关权利人依照法律规定应享有的权利除外。

6.2	您在使用南海新区维修资金服务平台的过程中，可能会使用到由第三方开发的在南海新区维修资金服务平台运行的功能、软件或服务，用户除遵守本协议相关规定以外，还应遵守第三方相关规定，并尊重第三方权利人对其功能、软件、服务及其所包含内容的相关权利。

6.3	未经南海新区维修资金服务平台或相关权利人书面同意，您不得为任何商业或非商业目的自行或许可任何第三方实施、利用、转让上述知识产权。


七、第三方提供的服务
 
7.1	本服务可能会使用第三方软件或技术，这种使用已经获得合法授权，您对本协议的签署及继续使用行为视为对接受第三方软件或技术服务的认可。

7.2	如因南海新区维修资金服务平台使用的第三方软件或技术引发的任何纠纷，应由该第三方负责解决，您使用南海新区维修资金服务平台上提供的产品或服务
时，除遵守本协议约定外，还应遵守第三方的服务或用户协议。南海新区维修资金服务平台和第三方之间对出现的纠纷在法律规定和约定的范围内各自承担责任。

八、风险及免责


8.1	您理解并同意：为了向您提供有效的服务，本服务会利用您终端设备的处理器和带宽等资源。在使用南海新区维修资金服务平台过程中可能产生数据流量的费用，您需自行向运营商了解相关资费信息，并自行承担相关费用。

8.2	您在使用南海新区维修资金服务平台提供的服务时，须自行承担如下南海新区维修资金服务平台不可掌控的风险内容，包括但不限于：

(1)	南海新区维修资金服务平台系统停机维护期间；

(2)	电信设备出现故障不能进行数据传输的；

(3)	由于网络供应商技术调整或故障、网站升级、银行方面的问题等原因而造成的服务中断或延迟；

(4)	用户的电脑软件、系统、硬件和通信线路出现故障；

(5)	用户操作不当或通过非南海新区维修资金服务平台授权的方式使用本服务；

(6)因受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏、台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成系统障碍不能执行业务的。
(7)	其他南海新区维修资金服务平台无法控制或合理预见的清形。

8.3	因您的过错导致的任何损失由您自行承担，该过错包括但不限于：不按照提示操作，未及时进行操作，遗忘或泄漏密码、校验码等，密码被他人破解，您使用的计算机或其他硬件、终端等被他人侵入或丢失，或您使用的软件被他人侵入，或者您的个人生物识别信息被他人利用。

8.4	您理解并同意，因业务发展需要，南海新区维修资金服务平台有权在提前告知的前提下，对南海新区维修资金服务平台的全部或部分服务内容进行变更、暂停、限制、终止或撤销，用户需承担此风险。

8.5	南海新区维修资金服务平台会根据您选择的服务类型向您提供相应的服务。您理解并同意，南海新区维修资金服务平台有权选择提供服务或开展合作的对象，有权决定功能开放、数据接口和相关数据披露的对象和范围，并有权视具体情况中止或终止向存有包括但不限于以下情形的用户提供本服务：

(1)	违反法律法规或本协议规定的；

(2)	影响使用者体验的；

(3)	存在安全隐患的；

(4)	违背本服务运营原则，或不符合南海新区维修资金服务平台其他管理要求的。

九、法律责任


9.1	您理解并同意，南海新区维修资金服务平台有权依合理判断对违反有关法律法规或本协议规定的行为追究责任，对违法违规的任何人士采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，您应独自承担由此而产生的—切法律责任。
9.2	您理解并同意，因您违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任；南海新区维修资金服务平台因此遭受损失的，您也应当—并赔偿。

9.3	您理解并同意，您可向南海新区维修资金服务平台进行的任何索赔均限于已经发生的直接损失。

十、	协议的更新、变更


10.1	协议的更新

本协议内容同时包括南海新区维修资金服务平台可能不定期发布的关于本服务的相关协议、服务声明、业务规则及公告指引等内容。上述内容—经正式发布，即为本协议不可分割的组成部分，请同样遵守。否则，请立即停止使用本服务。

10.2	协议的变更

您使用本服务即视为您已阅读并同意受本协议的约束。南海新区维修资金服务平台有权在必要时修改本协议条款。您在享受各项服务时，可以在相关页面中查阅最新的协议条款。本协议条款变更后，如果您继续使用本服务，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用本服务，注销平台账号、停止使用本服务。

10.3	协议的签署形式

如您对本协议条款内容有任何疑间，可向平台客服咨询。—旦点击“同意”或“接受”或“注册”按钮并成功注册，则与南海新区维修资金服务平台之间形成协议关系，应当受本协议条款的约束。

十一、	法律适用及管辖
 
11.1	本协议的签订地为威海市。

11.2	本协议的订立、变更、执行和解释，以及与本协议有关的争议解决，均应适用中华人民共和国法律。如与本协议有关的某—特定事项没有法律规定或规定不明确，则应参照通用的国际商业惯例和行业惯例。

11.3	如因本协议或本服务所引起或与其有关的任何争议应向威海仲裁委员会提起仲裁。

十二、	通知与送达


12.1	所有发给您的通知都可通过您在平台预留的通讯方式，以电子邮件、常规的信件或在网站显著位置公告的等方式进行传送。平台将通过上述方法之—将消息传递给您，告知您服务条款的修改、服务变更、或其它重要事情。

12.2	您应当保证和维持资料的有效性，您的资料若存在虚假、无效等任何可能导致您无法及时获取业务通知、客户服务、投诉处理、纠纷协调、技术支持等情况的，由您自行承担相应责任。

12.3	南海新区维修资金服务平台可以不定期以网页公告、电子邮件、手机短信、站内信、即时通讯工具等方式中的—种或多种向您发送与本服务有关的业务通知、服务提示、验证消息等各种业务通知。

12.4	各方均应保证其联系方式真实、有效，通知自发送之日视为己送达收件人。

十三、	其他


13.1	本协议自您同意勾选并成功注册为南海新区维修资金服务平台用户之日起生效，除非南海新区维修资金服务平台终止本协议或者您丧失南海新区维修资金服务平台用户资格，否则本协议始终有效。本协议终止并不免除用户根据本协议或
 
其他有关协议、规则所应承担的义务和责任。


13.2	本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。

            </div>
        </van-dialog>
        <!-- 隐私条款的弹框 -->
        <van-dialog v-model:show="hides" title="隐私条款" :lock-scroll='false' show-cancel-button :show-confirm-button='false'>
            <div style="padding:10px 15px;font-size:14px;height:250px;overflow:auto">
南海新区维修资金服务平台非常重视保护您的隐私。

为方便您登录、使用相关服务，以及为您提供更个性化的用户体验和服务，您在使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望
通过本隐私政策向您说明，在使用南海新区维修资金服务平台（以下统称“南海新区维修资金服务平台)时，我们如何收集、使用、储存和披露您的信息，以及我们为您提供的访间、更新、控制和保护这些信息的方式。本隐私政策与您所使用的南海新区维修资金服务平台信息及个人隐私信息相关，希望您仔细阅读。
您阅读并同意本隐私政策后，即意味着您已经同意我们按照本隐私政策收集、使用、储存和披露您的相关信息，以及向您提供的控制和保护措施。

一、适用范围

1.1本隐私政策适用于南海新区维修资金服务平台的所有服务，服务包括向您提供页面浏览、网站登录服务，以及通过南海新区维修资金服务平台向您提供的技术服务等。1.2本隐私政策中的“信息特指第二条所收集的信息。

二、信息收集范围

2.1	为完成南海新区维修资金服务平台账户的注册、管理、实名认证等必要活动，您需要提交真实、合法、有效的信息，包括但不限于您的姓名、身份证号码、身份证有效期、联系电话、人脸生物信息、微信昵称、头像等。
2.2	您使用本服务时，可能收集已经经过您授权获取或主动填写的如下信息：
2.2.1	日志信息指您用我们的服务时，系统可能通过自动采集的技术信息，包括：
•	设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码。
•	有关您曾使用的移动应用和其他软件的信息，以及您曾经使用该等移动应用和软件的信息。
•	您通过我们的服务进行通讯的信息，例如曾通讯的帐号。
•	您通过我们的服务分享的内容所包含的信息（元数据），例如拍摄或上传的共享照片或录像的日期、时间或地点等。
2.2.2位置信息，指您开启设备定位功能并使用我们基于位置提供的相关服务时，收集的有关您位置的信息，包括：
•	您通过具有定位功能的移动设备使用我们的服务时，通过GPS或WiFi等方式收集的您的地理位置信息。
•	您或其他用户提供的包含您所处地理位置的实时信息，例如您提供的账户信息中包含的您所在地区信息，您上传的显示您当前或曾经所处地理位置的共享信息，您或其他人共享的照片包含的地理标记信息。
•	您可以通过关闭定位功能，停止对您的地理位置信息的收集。
2.3	如果您需要使用部分可选的功能或服务如公积金、社保、公共交通、税务、户政、公共服务等，您还应该提供使用该功能或服务所必须的信息，如性别、出生日期、出生地、户籍所在地、民族等。
2.4	如果您需要在线上申请线下交付或进行产品测试，为履行所必需，您应提供联系人、联系方式、地址等必要信息。

三、如何收集信息
3.1	我们通过您主动提交，以及在您使用我们的服务过程中产生相应的记录等方式收集您的信息。
3.2	我们可能会通过数据埋点和其他相关技术收集和使用您的信息。我们使用数据埋点的具体用途包括：
•	分析您使用我们服务的清况，以便为您提供更加周到的个性化服务，包括定制化页面、推荐等服务。
3.3	通过南海新区维修资金服务平台数据埋点记录的有关信息，将适用本隐私政策。

四、信息使用
为了向您提供更加优质、便捷、安全的服务，在符合相关法律法规的前提下，我们可能将收集的信息用作以下用途：
•	向您提供服务（如实名认证信息、用来接受验证码的手机号，是继续获得服务的前提）。
•	满足您的个性化需求。例如，语言设定、位置设定、个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应。
•	服务优化和开发。例如，我们会根据南海新区维修资金服务平台系统响应您的需求时产生的信息，优化我们的服务。
•	保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或南海新区维修资金服务平台相关协议、规则的清况，我们可能使用您的帐号信息、并整合设备信息、有关网络日志以及我们关联公司、合作伙伴分享的信息，来判断您账户风险、进行身份验证、安全事件的检测及防范，并依法采取必要的记录、审计、分析、处置措施。例如，我们会将您的信息用于身份验证、安全防范、投诉处理、纠纷协调、诈骗监测等用途。您在使用安全功能或其他类似服务时，我们会对恶意程序或病毒进行检测，或为您识别诈骗信息。
•	向您提供与您更加相关的服务。例如，向您提供您可能感兴趣的类似功能或服务等。
•	邀请您参与有关我们产品和服务的调查。
•	其他可能需要使用收集的信息的相关场景，如果使用场景与初始场景无合理的关联性，我们会在使用信息前重新征得您的同意。

五、信息共享、转让、披露
5.1	信息共享
我们不会与其他组织和个人共享您的用户信息，但以下情况除外：
5.1.1	在获取明确同意的清况下共享：获得您的明确同意后，我们会与其他方共享您的用户信息；
5.1.2	在法定清形下的共享：我们可能会根据法律法规规定、诉讼、仲裁解决需要，或按行政、司法机关依法提出的要求，对外共享您的用户信息；
5.1.3	为了促成办理服务或协助解决争议，某些情况下只有共享您的用户信息，
才能促成办理或处理您与他人的纠纷或争议。
5.1.4	与授权合作伙伴共享：我们可能委托受信赖的合作伙伴来提供服务（如人脸识别服务），因此我们可能会与合作伙伴共享您的某些用户信息，以提供更好的客户服务和优化用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的用户信息，并且只会共享提供服务所必要的用户信息。我们的合作伙伴无权将共享的用户信息用于任何其他用途。
目前，我们的授权合作伙伴包括如下类型：供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供基础技术服务、提供咨询、分析等专业服务。
对我们与之共享用户信息的公司、组织和个人，我们会与其签署严格的保密协议以及信息保护约定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理用户信息。
5.2	转让
我们不会将您的用户信息转让给任何公司、组织和个人，但以下情况除外：
5.2.1在获取明确同意的清况下转让：获得您的明确同意后，我们会向其他方转让您的用户信息。
5.3	披露
未经您同意，我们不会与任何无关第三方分享您的信息，以下情形除外：
5.3.1.	我们可能将您的信息与我们的关联公司、第三方服务提供商、承包商及代理分享，仅用作下列用途：
•	提供“二、信息收集范围”中的相应功能或服务所必需，以及出于“四、信息使用“中的部分所述目的所必需。
如我们与任何上述第三方分享您的信息，我们将努力确保第三方在使用您的信息时遵守本声明及我们要求其遵守的其他适当的保密和安全措施。
5.3.2.	随着我们业务的持续发展，我们以及我们的关联公司有可能进行合并、
收购、资产转让或类似的交易，您的信息有可能作为此类交易的—部分而被转移。我们将遵守相关法律法规的要求，在转移前通知您，确保信息在转移时的机密性，以及变更后继续履行相应责任和义务。
5.3.3.	我们还可能因以下原因而披露您的信息：
•	遵守适用的法律法规等有关规定。
•	遵守法院判决、裁定或其他法律程序的规定。
•	遵守相关政府机关或其他有权机关的要求。
•	我们有理由确信需遵守法律法规等有关规定。
•	为执行相关服务协议或本隐私政策、维护社会公共利益、处理投诉／纠纷，保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途。
•	经过您合法授权的情形。
如我们因上述原因而披露您的信息，我们将在遵守法律法规相关规定及本声明的基础上及时告知您。

六、信息存储

6.1	南海新区维修资金服务平台收集的有关您的信息保存在南海新区维修资金服务平台位于中国大陆的服务器，微信本身不会留存您的任何信息。
6.2	通常，我们仅在为您提供服务期间保留您的信息，保留时间不会超过满足相关使用目的所必须的时间。
但在下列情况下，且仅出于下列情况相关的目的，我们有可能需要较长时间保留您的信息或部分信息：
•	遵守适用的法律法规等有关规定。
•	遵守法院判决、裁定或其他法律程序的要求。
•	遵守相关政府机关或其他有权机关的要求。
•	我们有理由确信需遵守法律法规等有关规定。
•	为执行相关服务协议或本隐私政策、维护社会公共利益、处理投诉／纠纷，保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途。

七、信息安全
如果您拥有南海新区维修资金服务平台其他账号，在特定场景下，您的南海新区维修资金服务平台账号的个人信息（身份证、手机号、姓名）可能会与您在南海新区维修资金服务平台拥有的其他账户信息相关联。例如，您使用微信支付注册南海新区维修资金服务平台账号。
7.1	我们努力保障信息安全，以防信息的丢失、不当使用、未经授权阅览或披露。
•	我们使用各种安全技术以保障信息的安全。例如，我们将通过服务器多备份、密码加密等安全措施，防止信息泄露、毁损、丢失。
•	我们建立严格的管理制度和流程以保障信息的安全。例如，我们严格限制访间信息的人员范围，并进行审计，要求他们遵守保密义务。
•	我们重视信息安全合规工作，并通过众多国际和国内的安全认证，如网络安全等级保护认证等，以业界先进的解决方案充分保障您的信息安全。
但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网环境下，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。
若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，按照《国家网络安全事件应急预案》等有关规定及时上报，并以发送邮件、推送通知、公告等形式告知您相关情况，并向您给出安全建议。
7.2	为更有效的保障您的信息安全，我们也希望您能够加强自我保护意识。我们仅在南海新区维修资金服务平台直接导致您个人信息泄露的范围内承担责任，因此，请您妥善保管您的账号及密码信息，避免您的个人信息泄露。南海新区维修资金服务平台账户及微信账号均有安全保护功能，但您也需要妥善保护自己的个人信息，除非您判断认为必要的情形下，不向任何第三人提供您的账号密码等个人信息。

八、访问与控制

8.1	您可以在使用我们服务的过程中，访间、修改和删除您的相关信息。您访问、修改和删除信息的方式将取决于您使用的具体服务。
8.2	如您发现我们违反法律法规的规定或者双方的约定收集、使用您的信息，您可以要求我们删除。如您发现我们收集、存储的您的信息有错误的，且无法自行更正的，您也可以要求我们更正。
8.3	在访问、修改和删除相关信息时，我们可能会要求您进行身份验证，以保障账户安全。请您理解，由于技术所限、基于法律法规要求，您的某些请求可能无法进行响应。
8.4	基于法律法规要求、保障信息安全等正当事由，您的部分信息可能无法访间、修改和删除。
8.5	您可以自行选择撤回对某些非基本功能或服务对您信息处理的同意，并通过联系客服的方式选择注销南海新区维修资金服务平台账号。
8.6	如您对上述权利实现存在疑间，可以根据“十、与我们联系”中的相关联系方式与我们取得联系。

九、隐私政策的更新

我们可能适时修订本隐私政策的条款，该等修订构成本《隐私政策》的—部分。如可能造成您在本隐私政策下权利的实质减少或扩大收集、使用信息的范围等重要规则变更时，我们将在修订生效前通过在主页上显著位置弹窗提示或向您发送电子邮件或以其他方式通知您。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的本隐私政策的约束。

十、与我们联系

如您对本政策或其他相关事宜有疑间，您可以通过【账户中心-联系我们】查询并电话联系我们。我们将尽快审核所涉间题，并在验证您的用户身份后予以回复。

            </div>
        </van-dialog>
    </div>
</template>

<script>
    import VueCookie from 'vue-cookie'
    export default {
        data() {
            return {
                obj:{},
                id:'',
                isRealName:0,//是否认证 0为未认证  1是已认证
                headImgUrl:'',//获取头像
                fullname:'',
                idcard:'',
                realIdCard:'',//身份证号码
                realName:'',//姓名
                phone:'',//手机号码
                show: false,
                inmation:false,
                contact:false,
                userdia:false,
                hides:false,
                authentication: '已认证'
            }
        },
        beforeRouteLeave(to,from,next){
            // this.$nextTick(()=>{
            //     if(this.inmation||this.contact||this.userdia||this.hides){
            //         this.inmation = false
            //         this.contact = false
            //         this.userdia = false
            //         this.hides = false
            //     }
            // })
            // next()
            this.$nextTick(()=>{
                if(this.inmation||this.contact||this.userdia||this.hides){
                    next(false)
                }else{
                    next(true)
                }
                // if(this.inmation){
                //     this.inmation = false
                //     next(false)
                // }else if(!this.inmation){
                //     next(true)
                // }else if(this.contact){
                //     this.contact = false
                //     next(false)
                // }else if(!this.contact){
                //     next(true)
                // }else if(this.hides){
                //     this.hides = false
                //     next(false)
                // }else if(!this.hides){
                //     next(true)
                // }
            })
        },
        methods: {
            goHome() {
                history.go(-1);
                // this.$router.push({
                //     path: '/'
                // });
            },
            openInmation(){
                this.inmation = true
                this.AuthenPeople()
            },
            //先调接口
            ContentMy(){
                let data={
                    noticeType:3,
                    state:1,
                    pageNum:1,
                    pageSize:10
                }
                this.$postQuery('/weChatNotice/getNoticeListByType', data).then((response) => {
                    if(response.code==200){
                        this.id = response.data.list[0].id
                    }
                })
            },
            // 联系我们
            openContact(){
                if(this.id){
                    let data={
                        id:this.id
                    }
                    this.$postQuery('/weChatNotice/getNoticeDetailById', data).then((response) => {
                        if(response.code==200){
                            this.obj = response.data
                        }
                    })
                    this.contact = true
                }else{
                    this.$toast('暂无。。。')
                }
            },
            openUserdia(){
                this.userdia = true
            },
            openHides(){
                this.hides = true   
            },
            AuthenPeople(){
                let data = {
                    // openId:'o5AgcxKDu14LYiSrhGBzj_rMu7ZM'
                    openId:VueCookie.get('openid')
                }
                this.$postQuery('/WeChat/getUserInfoByOpenId', data).then((response) => {
                    console.log(response.data,'getUserInfoByOpenId接口的返回结果')
                    this.realIdCard = response.data.realIdCard
                    this.realName = response.data.realName
                    this.phone = response.data.phone
                })
            }
        },
        created(){
            // 头像取cookie
            this.headImgUrl = VueCookie.get('headImgUrl')
            //是否认证取cookie
            this.isRealName = VueCookie.get('isRealName')
            //取姓名cookie
            this.fullname = VueCookie.get('fullname')
            //取身份证号cookie
            this.idcard = VueCookie.get('Idcard')
            this.ContentMy()
            // if(this.isRealName==0){
            //     this.authentication='未认证'
            // }else if(this.isRealName==1){
            //     this.authentication = '已认证'
            // }
            // this.AuthenPeople()
        }
    }
</script>

<style scoped>
    .list {
        margin-top: 46px;
    }

    .flex {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
    }
    .flex .house_button{
        margin: 10px;
    }
    .flex  .house_button .van-button,.content_button .van-button{
        padding: 3px 15px;
        width: 100%;
    }
</style>